import { Stack } from "@mui/material";
import { CPButton } from "@warden-ui/common-components";
import { CPAlert } from "@warden-ui/common-components";
import { CPCard } from "@warden-ui/common-components";
import { useTranslation } from "react-i18next";

interface CardContentResetPasswordRequestProps {
  email?: string;
  migration?: boolean;
  onClickResetPasswordRequest?: () => void;
  loading?: boolean;
  errorMessage?: string;
}

export const CardContentResetPasswordRequest = ({
  email = "",
  migration = false,
  onClickResetPasswordRequest,
  ...props
}: CardContentResetPasswordRequestProps) => {
  const { t } = useTranslation();
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (onClickResetPasswordRequest) {
      onClickResetPasswordRequest();
    }
  }

  return (
    <CPCard>
      <span className="cp-line-height-lg cp-text-h1 font-weight-regular">
        {migration ? t('reset_password.title.reset') : t('reset_password.title.forgot')}
      </span>

      <Stack spacing={3} className="w-100">
        <span className="cp-hint">
          {migration ? t('reset_password.content.migration'): t('reset_password.content.instruction', { email})}
        </span>
        
        <CPAlert message={props.errorMessage} />

        <form onSubmit={handleSubmit} className="w-100">
          <CPButton
            label={t('buttons.reset_password')}
            loading={props.loading}
          />
        </form>
      </Stack>
    </CPCard>
  );
};
